export default __webpack_public_path__ + "resources/icons/d430-4273.png";